document
  .querySelectorAll(".product_compatible_accessories_bottom_right")
  .forEach((button) => {
    button.addEventListener("click", function () {
      this.classList.toggle("show_more");
      const accessoryList = this.closest(
        ".product_compatible_accessories_block"
      )
        .querySelector(".product_compatible_accessories_list")
        .querySelectorAll(".product_compatible_accessorie_more");
      accessoryList.forEach((accessory) => {
        accessory.classList.toggle("hide");
      });
    });
  });

document.querySelectorAll(".pro_variant_radio").forEach((radio) => {
  radio.addEventListener("change", function () {
    const checkboxInput = this.closest(
      ".product_compatible_accessorie"
    ).querySelector(".product_compatible_accessorie_checkbox input");
    checkboxInput.value = this.value;
  });
});

document
  .querySelectorAll(".compatible_accessorie_checkbox")
  .forEach((checkbox) => {
    checkbox.addEventListener("change", function (event) {
      const isChecked = event.target.checked;
      const overlay = this.closest(
        ".product_compatible_accessorie"
      ).querySelector(".product_compatible_accessorie_overlay");

      if (isChecked) {
        overlay.classList.add("product_compatible_accessorie_overlay_show");
        setTimeout(() => {
          overlay.classList.remove(
            "product_compatible_accessorie_overlay_show"
          );
        }, 2000);
      } else {
        overlay.classList.remove("product_compatible_accessorie_overlay_show");
      }

      const selectedCheckboxes = document.querySelectorAll(
        ".compatible_accessorie_checkbox:checked"
      );

      const selectedCount = selectedCheckboxes.length;
      const bottomLeftElement = document.querySelector(
        ".product_compatible_accessories_bottom_left"
      );

      if (selectedCount > 0) {
        let totalPrice = 0;
        selectedCheckboxes.forEach((checkbox) => {
          totalPrice += checkbox.getAttribute("data-price") * 1;
        });
        let discount_price = totalPrice * 0.1;
        bottomLeftElement.innerHTML = `<span style="color:rgb(var(--color-sale-off-price));">Already Saved <strong>${Shopify.formatMoney(
          discount_price
        )}</strong> ！</span>`;
      } else {
        bottomLeftElement.innerHTML = "";
      }
    });
  });

// new shop 优化
// 视频区域动画
 document.addEventListener("DOMContentLoaded", function () {
  // 移动端不执行动画，直接填充文本
  if (window.innerWidth <= 900) {
    document.querySelectorAll(".new-shop-video-title, .new-shop-video-subtitle").forEach(function(line){
      line.innerHTML = line.getAttribute("data-text") || "";
    });
    return;
  }
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined")
    return;
  const videoSection = document.querySelectorAll(".new-shop-video-section");
  if (!videoSection || videoSection.length === 0) return;
  videoSection.forEach((section) => {
    const title = section.querySelector(".new-shop-video-title");
    const subtitle = section.querySelector(".new-shop-video-subtitle");

    // 直接填充文字内容
    title.innerHTML = title.getAttribute("data-text") || "";
    subtitle.innerHTML = subtitle.getAttribute("data-text") || "";

    const mask = section.querySelector(".new-shop-video-mask");
    const content = section.querySelector(".new-shop-video-content");
    const delayPx = window.innerHeight * 0.5;
    const scrollLength = window.innerHeight * 0.5;
    const totalLength = delayPx + scrollLength;
    mask.style.transform = "translateY(100%)";
    
    // 初始显示内容
    content.style.display = "none";

    ScrollTrigger.create({
      trigger: section,
      start: `bottom bottom`,
      end: `bottom+=${totalLength} bottom`,
      pin: true,
      scrub: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      fastScrollEnd: true,
      fastScrollEndDelay: 0.1,
      onUpdate: (self) => {
        const progress = self.progress; // 0~1

        let maskProgress =
          Math.min(progress, delayPx / totalLength) / (delayPx / totalLength);
        maskProgress = Math.max(0, Math.min(1, maskProgress));
        mask.style.transform = `translateY(${100 - 100 * maskProgress}%)`;

        // 蒙层未到80%时隐藏内容
        if (maskProgress < 0.8) {
          content.style.display = "none";
        } else {
          content.style.display = "flex";
        }
      },
    });
    window.addEventListener("resize", () => ScrollTrigger.refresh());
  });
});

// 公共函数：初始化Best Seller模块
  function initBestSellerSection(sectionId) {
    const section = document.getElementById(sectionId);
    if (!section) {
      console.warn("Best Seller section not found:", sectionId);
      return;
    }
  
    // 防止重复初始化
    if (section.dataset.initialized === "true") {
      return;
    }
  
    try {
      // 初始化标签页切换
      const tabs = section.querySelectorAll(".new-shop-best-seller-tab");
      const panels = section.querySelectorAll(".new-shop-best-seller-panel");
  
      tabs.forEach((tab, idx) => {
        tab.addEventListener("click", function () {
          tabs.forEach((t) => t.classList.remove("active"));
          panels.forEach((p) => p.classList.remove("active"));
          tab.classList.add("active");
          panels[idx].classList.add("active");
          setTimeout(() => {
            panels[idx].querySelectorAll(".swiper-slide").forEach((slide) => {
              slide.classList.remove("fade-in-up");
              void slide.offsetWidth;
              slide.classList.add("fade-in-up");
            });
          }, 10);
        });
      });
  
      // 初始化产品缩略图轮播
      section
        .querySelectorAll(".new-shop-best-seller-product-thumbs")
        .forEach(function (swiperEl) {
          if (swiperEl.swiper) {
            swiperEl.swiper.destroy();
          }
          const swiper = new Swiper(swiperEl, {
            slidesPerView: 4,
            spaceBetween: 10,
          });
          const slides = swiperEl.querySelectorAll(".swiper-slide");
          if (slides.length) {
            slides[0].classList.add("selected");
          }
          slides.forEach(function (slide) {
            slide.addEventListener("click", function (e) {
              e.preventDefault();
              e.stopPropagation();
  
              // 移除所有选中状态
              slides.forEach((s) => s.classList.remove("selected"));
              // 添加当前选中状态
              slide.classList.add("selected");
  
              const img = slide.querySelector("img");
              if (img) {
                // 查找当前缩略图所属的产品卡片
                const productCard = slide.closest(
                  ".new-shop-best-seller-product-card"
                );
                if (productCard) {
                  // 在产品卡片中查找主图
                  const mainImg = productCard.querySelector(
                    ".new-shop-best-seller-product-main-img img"
                  );
                  if (mainImg) {
                    // 获取原始图片URL并转换为大尺寸
                    let newSrc = img.src;
                    // 处理不同尺寸的图片URL
                    if (newSrc.includes("100x100")) {
                      newSrc = newSrc.replace("100x100", "400x400");
                    } else if (newSrc.includes("_100x100")) {
                      newSrc = newSrc.replace("_100x100", "_400x400");
                    } else if (newSrc.includes("&width=100")) {
                      newSrc = newSrc.replace("&width=100", "&width=400");
                    } else {
                      // 如果没有尺寸参数，尝试添加尺寸参数
                      if (newSrc.includes("?")) {
                        newSrc += "&width=400&height=400";
                      } else {
                        newSrc += "?width=400&height=400";
                      }
                    }
  
                    // 更新主图
                    mainImg.src = newSrc;
                    mainImg.alt = img.alt || mainImg.alt;
                  } else {
                    console.warn("Main image not found in product card");
                  }
                } else {
                  console.warn("Product card not found");
                }
              } else {
                console.warn("No image found in thumb slide");
              }
            });
          });
        });
  
      // 初始化主轮播
      section.querySelectorAll('.new-shop-best-seller-panel-swiper').forEach(function (swiperEl, idx) {
        if (swiperEl.swiper) {
          swiperEl.swiper.destroy();
        }
        
        const swiper = new Swiper(swiperEl, {
          slidesPerView: 4,
          spaceBetween: 24,
          autoHeight: false,
          navigation: {
            nextEl: '.new-shop-best-seller-panel-swiper-next-' + idx,
            prevEl: '.new-shop-best-seller-panel-swiper-prev-' + idx,
          },
          breakpoints: {
            1200: {
              slidesPerView: 4,
            },
            900: {
              slidesPerView: 3,
            },
            600: {
              slidesPerView: 2,
            },
            500: {
                slidesPerView: 'auto',
            },
            0: {
              slidesPerView: 'auto'
            }
          },
          loop: false,
          on: {
            init: function() {
              updateNavigationButtons(this);
            },
            slideChange: function() {
              updateNavigationButtons(this);
            },
            resize: function() {
              updateNavigationButtons(this);
            }
          }
        });
        
        // 更新导航按钮显示状态的函数
        function updateNavigationButtons(swiperInstance) {
          const prevBtn = swiperInstance.el.querySelector('.swiper-button-prev');
          const nextBtn = swiperInstance.el.querySelector('.swiper-button-next');
          
          if (prevBtn) {
            prevBtn.style.display = swiperInstance.isBeginning ? 'none' : 'flex';
          }
          if (nextBtn) {
            nextBtn.style.display = swiperInstance.isEnd ? 'none' : 'flex';
          }
        }
      });
  
      // 标记为已初始化
      section.dataset.initialized = "true";
    } catch (error) {
      console.error("Error initializing Best Seller section:", sectionId, error);
    }
  }
  
  // 页面加载完成后初始化所有Best Seller模块
  document.addEventListener("DOMContentLoaded", function () {
    // 查找所有Best Seller模块并初始化
    const bestSellerSections = document.querySelectorAll(".new-shop-best-seller");
    bestSellerSections.forEach(function (section) {
      const sectionId = section.id;
      if (sectionId) {
        initBestSellerSection(sectionId);
      }
    });
  });
  
  // 监听Shopify主题编辑器的事件
  document.addEventListener("shopify:section:load", function (event) {
    if (event.target.classList.contains("new-shop-best-seller")) {
      const sectionId = event.target.id;
      if (sectionId) {
        initBestSellerSection(sectionId);
      }
    }
  });
// new shop 菜单优化
document.addEventListener("DOMContentLoaded", () => {
  // new-shop mega menu 交互
  class NewShopMegaMenu {
    constructor(menuDetailElement) {
      this.container = menuDetailElement;
      this.navItems = this.container.querySelectorAll(
        ".new-shop-mega-menu__nav-item"
      );
      this.contentPanels = this.container.querySelectorAll(
        ".new-shop-mega-menu__list"
      );
      if (this.navItems.length === 0) return;
      this.bindEvents();
      this.init();
    }
    init() {
      const initialActiveItem = this.container.querySelector(
        '[data-init-active="true"]'
      );
      if (initialActiveItem) {
        this.activate(initialActiveItem);
      } else {
        this.activate(this.navItems[0]);
      }
    }
    bindEvents() {
      this.navItems.forEach((item) => {
        item.addEventListener("mouseenter", () => this.activate(item));
      });
    }
    activate(itemToActivate) {
      if (!itemToActivate) return;
      const handle = itemToActivate.dataset.menuHandle;
      const contentToShow = this.container.querySelector(
        `.new-shop-mega-menu__list[data-menu-handle="${handle}"]`
      );
      this.navItems.forEach((item) => item.classList.remove("is-active"));
      this.contentPanels.forEach((panel) =>
        panel.classList.remove("is-active")
      );
      itemToActivate.classList.add("is-active");
      if (contentToShow) {
        contentToShow.classList.add("is-active");
      }
    }
  }
  const megaMenus = document.querySelectorAll("details.mega-menu");
  megaMenus.forEach((menu) => {
    new NewShopMegaMenu(menu);
  });
});
